import AutoAcceptOrderModal from "@/Components/Modal/AutoAcceptOrderModal";
import Spinner from "@/Components/Spinner/Spinner";
import { useSetLiveFilters } from "@/shared/atoms/useLiveFilters";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import { orderStatusses } from "@/shared/utils/constant";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import { useEffect } from "react";
import Live from "./Live";

const Loader = ({ data }: { data: OrdersLive }) => {
  const { data: settings, isPending } = useUserSettingsQuery();
  const setFilters = useSetLiveFilters();

  useEffect(() => {
    if (settings) {
      if (settings.lanes?.length > 0) {
        setFilters(
          orderStatusses
            .filter((statue) => !settings.lanes.includes(`${statue.value[0]}`))
            .map((statue) => statue.value[0])
        );
      } else setFilters([]);
    }
  }, [settings]);

  if (isPending) {
    return (
      <div className="mt-40 flex justify-center">
        <Spinner size="0.8rem" />
      </div>
    );
  }

  if (!isPending && !settings?.is_active) {
    return (
      <div className="mt-40 flex justify-center">
        <AutoAcceptOrderModal />
      </div>
    );
  }

  return <Live data={data} />;
};

export default Loader;
